export { };

declare global {
  interface String {
    toLowerCaseFirstLetter();
  }
}

if (typeof String.prototype.toLowerCaseFirstLetter !== 'function') {
  String.prototype.toLowerCaseFirstLetter = toLowerCaseFirstLetter;
}

function toLowerCaseFirstLetter() {
  return this && this.replace(/./, this.toLowerCase()[0]);
}
